import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { VERTICALS } from "../../constants/app-constant";
import {
  BlogForumsIcon,
  BlogIcon,
  FacebookIcon,
  FacebookWBIcon,
  GlobeIcon,
  InstagramIcon,
  InstagramWBIcon,
  LinkedInIcon,
  PrintIcon,
  SocialBlogIcon,
  SocialForumIcon,
  TwitterIcon,
  TwitterWBIcon,
} from "../Icons/icons.component";
import SocialIcon from "../NewsAndAnalysis/SocialIcon";
const {
  V_ONLINE,
  V_BLOG,
  V_PRINT,
  V_FORUM,
  V_SOCIAL,
  V_TV,
  TWITTER_INSIGHTS,
  V_PRINT_AND_ONLINE,
  LINKEDIN_INSIGHTS,
  FACEBOOK_INSIGHTS,
  INSTAGRAM_INSIGHTS
} = VERTICALS;

export default function VerticalTag({ type }) {
  return (
    <>
    <ButtonGroup className="smallToggleBtnGroup">
      {type === V_PRINT && (
        <Button className={"tagOrange active"} value={"print"}>
          <PrintIcon />
          Print
        </Button>
      )}
      {type === V_ONLINE && (
        <Button className={"tagGreen active"} value={"online"}>
          <GlobeIcon />
          Online
        </Button>
      )}
      {type === V_PRINT_AND_ONLINE && (
        <Button className={"tagBlue active"} value={"online"}>
          <GlobeIcon />
          Print & Online
        </Button>
      )}
       
      {type === V_SOCIAL && (
        <Button className="tagBlue active" value={"social"}>
          <SocialBlogIcon />
          Social
        </Button>
      )}
      {type === V_BLOG && (
        <Button className={"tagViolet active"} value={"blog"}>
          <BlogIcon />
          Blogs
        </Button>
      )}
      {type === V_TV && (
        <Button className={"tagGreen active"} value={"tv"}>
          <GlobeIcon />
          TV
        </Button>
      )}
      {type === V_FORUM && (
        <Button className={"tagBrown active"} value={"forum"}>
          <SocialForumIcon />
          Forum
        </Button>
      )}
      {type === TWITTER_INSIGHTS && (
        <Button className={"tagBlue active"} value={"social"}>
          <TwitterWBIcon cla={"icon-place"} />
          X
        </Button>
      )}
      {type === LINKEDIN_INSIGHTS && (
        <Button className={"tagBlue active"} value={"social"}>
          <LinkedInIcon cla={"icon-place"} />
          LinkedIn
        </Button>
      )}
      {type === FACEBOOK_INSIGHTS && (
        <Button className={"tagBlue active"} value={"social"}>
          <FacebookWBIcon cla={"icon-place"} />
          FaceBook
        </Button>
      )}
      {type === INSTAGRAM_INSIGHTS && (
        <Button className={"tagBlue active"} value={"social"}>
          <InstagramWBIcon cla={"icon-place"} />
          Instagram
        </Button>
      )}
    </ButtonGroup>
    </>
  );
}

VerticalTag.defaultProps = {
  type: "",
};
